export default class JoinNowAbstractServices {
  static getPredictiveAddress(addressLine) {
    logger.error(`JoinNow:: getPredictiveAddress(${addressLine}) not implemented`);
  }

  static getAddressDetails(addressLine) {
    logger.error(`JoinNow:: getAddressDetails(${addressLine}) not implemented`);
  }

  static getReferenceData() {
    logger.error(`JoinNow:: getReferenceData() not implemented`);
  }

  static getQuoteDetails(QuoteId) {
    logger.error(`JoinNow:: getQuoteDetails(${QuoteId}) not implemented`);
  }

  static uploadDocument(files, contentType, GUID, fileType) {
    logger.error(`JoinNow:: uploadDocument(${files}, ${contentType}, ${GUID}, ${fileType}) not implemented`);
  }

  static async getProductPrice(payload) {
    logger.error(`JoinNow:: getProductPrice(${payload}) not implemented`);
  }

  /**
   * @deprecated Since Bambora has been replaced by Ipsi.
   */
  static async convertSecureTransactionToken(sst) {
    logger.error(`JoinNow:: convertSST(${sst}) not implemented`);
  }

  static async createMembership(payload) {
    logger.error(`JoinNow:: createMembership(${payload}) not implemented`);
  }
}
